import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
// import { Label } from '@/components/ui/label' // Not used - observations commented
// import { Textarea } from '@/components/ui/textarea' // Not used - observations commented
import { DispatchAreaSelector } from '@/containers/billing/register/registerDetails/components/DispatchAreaSelector'

interface DispatchDialogProps {
  open: boolean
  onOpenChange: (_open: boolean) => void
  containerName: string
  selectedStockAreaId: string
  setSelectedStockAreaId: (_areaId: string) => void
  // observations: string // Not used in ungroup endpoint
  // setObservations: (_observations: string) => void // Not used in ungroup endpoint
  onConfirm: () => void
  onCancel: () => void
  isPending?: boolean
}

export function DispatchDialog({
  open,
  onOpenChange,
  containerName,
  selectedStockAreaId,
  setSelectedStockAreaId,
  // observations, // Not used in ungroup endpoint
  // setObservations, // Not used in ungroup endpoint
  onConfirm,
  onCancel,
  isPending = false,
}: DispatchDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Desagrupar contenedor</DialogTitle>
          <DialogDescription>
            Selecciona el área de almacén destino para desagrupar los productos
            de este contenedor
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Container Info */}
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
            <p className="text-sm text-gray-600">
              <span className="font-medium">Contenedor:</span> {containerName}
            </p>
          </div>

          {/* Stock Area Selection */}
          <DispatchAreaSelector
            autoSelectFirst={false}
            className="space-y-2"
            id="stock-area-select"
            label="Área de almacén destino"
            placeholder="Seleccionar área de almacén"
            selectedArea={selectedStockAreaId}
            setSelectedArea={setSelectedStockAreaId}
            showIcon={true}
            triggerClassName="w-full"
          />

          {/* Observations - Not used in ungroup endpoint */}
          {/* <div className="space-y-2">
            <Label htmlFor="dispatch-observations">
              Observaciones (opcional)
            </Label>
            <Textarea
              id="dispatch-observations"
              onChange={(e) => setObservations(e.target.value)}
              placeholder="Observaciones..."
              rows={3}
              value={observations}
            />
          </div> */}

          {/* Selected Area Confirmation */}
          {selectedStockAreaId && (
            <div className="rounded-lg border border-blue-200 bg-blue-50 p-3">
              <h4 className="text-sm font-medium text-blue-900">
                Se desagruparán los productos al área seleccionada
              </h4>
              <p className="mt-1 text-xs text-blue-700">
                Los productos del contenedor serán desagrupados a esta área de
                almacén.
              </p>
            </div>
          )}
        </div>

        <DialogFooter>
          <Button onClick={onCancel} variant="outline">
            Cancelar
          </Button>
          <Button
            disabled={!selectedStockAreaId || isPending}
            onClick={onConfirm}
          >
            {isPending ? 'Desagrupando...' : 'Desagrupar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
